export const langMessages = {
  langSuggestion: "Detected language:",
  auto: "Auto-detect",
  af: "Afrikaans",
  ak: "Twi (Akan)",
  am: "Amharic",
  ar: "Arabic",
  as: "Assamese",
  ay: "Aymara",
  az: "Azeri / Azerbaijani (Latin)",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bho: "Bhojpuri",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  bs: "Bosnian",
  ca: "Catalan",
  ceb: "Cebuano",
  ckb: "Kurdish (Central)",
  co: "Corsican",
  cs: "Czech",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  de_at: "German (Austria)",
  de_ch: "German (Switzerland)",
  de_de: "German (Germany)",
  doi: "Dogri",
  dv: "Dhivehi",
  ee: "Ewe",
  el: "Greek",
  el_cy: "Greek (Cyprus)",
  el_gr: "Greek (Greece)",
  en: "English",
  en_gb: "English (United Kingdom)",
  en_us: "English (United States)",
  eo: "Esperanto",
  es: "Spanish",
  es_419: "Spanish (Latin America)",
  es_mx: "Spanish (Mexico)",
  et: "Estonian",
  eu: "Basque",
  fa: "Farsi",
  fa_af: "Farsi (Afghanistan)",
  fa_ir: "Farsi (Iran)",
  fi: "Finnish",
  fil: "Filipino",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fr_be: "French (Belgium)",
  fr_ca: "French (Canada)",
  fr_ch: "French (Switzerland)",
  fr_fr: "French (France)",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gom: "Konkani",
  gu: "Gujarati",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  hmn: "Hmong",
  hr: "Croatian",
  ht: "Haitian",
  hu: "Hungarian",
  hy: "Armenian",
  id: "Indonesian",
  ig: "Igbo",
  ilo: "Ilocano",
  is: "Icelandic",
  it: "Italian",
  it_ch: "Italian (Switzerland)",
  it_it: "Italian (Italy)",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kk: "Kazakh",
  kl: "Greenlandic",
  kln_ke: "Kalenjin",
  km: "Khmer",
  kmr: "Kurdish (Northern)",
  kn: "Kannada",
  ko: "Korean",
  ks: "Kashmiri",
  ku: "Kurdish",
  ku_arab: "Kurdish (Arabic)",
  ky_kg: "Kyrgyz (Kyrgyzstan)",
  kz: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Luganda",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lus: "Mizo",
  lv: "Latvian",
  mai: "Maithili",
  mg: "Malagasy",
  mi: "Maori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian (Cyrillic)",
  mn_mong: "Mongolian (Traditional)",
  mni: "Manipuri",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  ne: "Nepali",
  nl: "Dutch",
  nl_be: "Dutch (Belgium)",
  nl_nl: "Dutch (Netherlands)",
  no: "Norwegian",
  nso: "Sepedi",
  ny: "Chewa",
  om: "Oromo",
  or: "Odia (Oriya)",
  pa: "Punjabi",
  pa_arab_pk: "Punjabi (Pakistan, Arabic)",
  pa_in: "Punjabi (India)",
  pa_pk: "Punjabi (Pakistan)",
  pl: "Polish",
  prs: "Dari",
  ps: "Pashto",
  pt: "Portuguese",
  pt_br: "Portuguese (Brazil)",
  pt_pt: "Portuguese (Portugal)",
  qu: "Quechua",
  ro: "Romanian",
  ro_md: "Romanian (Moldova)",
  ro_ro: "Romanian (Romania)",
  ru: "Russian",
  ru_ru: "Russian (Russia)",
  ru_ua: "Russian (Ukraine)",
  run: "Rundi",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sd: "Sindhi",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr_cyrl: "Serbian (Cyrillic)",
  sr_latn: "Serbian (Latin)",
  st: "Southern Sotho",
  su: "Sundanese",
  sv: "Swedish",
  sv_fi: "Swedish (Finland)",
  sv_se: "Swedish (Sweden)",
  sw: "Swahili",
  ta: "Tamil",
  ta_in: "Tamil (India)",
  te: "Telugu",
  tg: "Tajik",
  tg_cyrl: "Tajik (Cyrillic)",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen (Latin)",
  tl: "Tagalog",
  tlh: "Klingon",
  tn: "Tswana",
  to: "Tongan",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  ug: "Uyghur (Arabic)",
  uk: "Ukrainian",
  ur: "Urdu",
  uz_cyrl_uz: "Uzbek (Cyrillic)",
  uz_latn_uz: "Uzbek (Latin)",
  vi: "Vietnamese",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  "zh-cn": "Chinese",
  "zh-tw": "Chinese (Taiwan)",
  zh_hans: "Simplified Chinese (China)",
  zh_hant: "Traditional Chinese (Taiwan)",
  zh_hk: "Traditional Chinese (Hong Kong)",
  zh_sg: "Simplified Chinese (Singapore)",
  zu: "Zulu"
}